import { defineMessages } from "react-intl"

export const messages = defineMessages({
    "is_archived": {
        id: "stock_documents.listing.isArchived",
        defaultMessage: "Is Archived",
    },
    "contact_first_name": {
        id: "stock_documents.listing.contact_first_name",
        defaultMessage: "Contact first name",
    },
    "created_at": {
        id: "stock_documents.listing.filters.date.created_at",
        defaultMessage: "Created date",
    },
    "status": {
        id: "stock_documents.listing.headers.status_label",
        defaultMessage: "Status",
    },
    "status_filter_placeholder": {
        id: "stock_documents.listing.status_filter_placeholder",
        defaultMessage: "Filter by status",
    },
    "contact_last_name": {
        id: "stock_documents.listing.contact_last_name",
        defaultMessage: "Contact last name",
    },
    "contact_organization_name": {
        id: "stock_documents.listing.contact_organization_name",
        defaultMessage: "Contact organization name",
    },
    "contact_type": {
        id: "stock_documents.listing.contact_type",
        defaultMessage: "Contact type",
    },
    "contact_phonenumber": {
        id: "stock_documents.listing.contact_phonenumber",
        defaultMessage: "Contact phone number",
    },
    "contact_email": {
        id: "stock_documents.listing.contact_email",
        defaultMessage: "Contact email",
    },
    "contact_name": {
        id: "stock_documents.listing.contact_name",
        defaultMessage: "Contact name",
    },
    "contact_id": {
        id: "stock_documents.listing.contact_id",
        defaultMessage: "Contact id",
    },
    "tax_number": {
        id: "stock_documents.listingcustomer_tax_number_placeholder",
        defaultMessage: "Contact tax number",
    },
    "product_id": {
        id: "stock_documents.listing.headers.product_id",
        defaultMessage: "Product",
    },
    "product_label": {
        id: "stock_documents.listing.headers.product_label",
        defaultMessage: "Product label",
    },
    "product_title": {
        id: "stock_documents.listing.headers.product_title",
        defaultMessage: "Product title",
    },
    "product_sku": {
        id: "stock_documents.listing.headers.product_sku",
        defaultMessage: "Product sku",
    },
    "product_related_filters": {
        id: "stock_documents.listing.headers.product_related_filters",
        defaultMessage: "Product related filters",
    },
    "contact_related_filters": {
        id: "stock_documents.listing.headers.contact_related_filters",
        defaultMessage: "Contact related filters",
    },
    "most_used_filters": {
        id: "stock_documents.listing.headers.most_used_filters",
        defaultMessage: "Most used filters",
    },
})


// WEBPACK FOOTER //
// ./src/common/search-filter/search/stockDocumentsFilters/messages.ts